/* eslint-disable import/no-unused-modules */

/**
 * UI Constants for Asset Selection Components
 * Local constants for consistent icon sizing and UI elements
 */

// Icon size constants for asset items
export const ICON_SIZES = {
    SMALL: { width: 16, height: 16 },
    MEDIUM_24: { width: 24, height: 24 },
    LARGE: { width: 32, height: 32 }
};

// Component-specific size constants
export const COMPONENT_CONSTANTS = {
    // Available and Selected Asset Item icon size
    ASSET_ITEM_ICON_SIZE: ICON_SIZES.MEDIUM_24,

    // SubType selector icon size
    SUBTYPE_ICON_SIZE: ICON_SIZES.SMALL,

    // Asset preview icon size
    PREVIEW_ICON_SIZE: ICON_SIZES.LARGE
};
